import { OfferFactory, OfferFactoryError, StringifiedAmount, SpeciesOffer, OfferTarget } from '@/Domain/Offer'
import { Offer as VuexOffer } from '@/Infrastructure/Store/AuctionB/Offer'
import { Offer } from '@/Domain/Offer/Offer'
import { Currency } from '@/Domain/Batch/Currency'
import { ResultasOffer } from '@/Infrastructure/Store/AuctionB/ResultasOffer'
import { SpeciesBinomen } from '@/Domain/Batch/Species'

export class VuexOfferFactory implements OfferFactory<VuexOffer> {
  makeOffer (data: VuexOffer): Offer {
    try {
      let speciesOffers: SpeciesOffer[] = []
      if (data.resultasOffers && data.resultasOffers.length > 0) {
        speciesOffers = this.makeResultasOffer(data.resultasOffers)
      }
      return new Offer(
        Currency.fromString(data.global.numberBid),
        new StringifiedAmount(data.global.textBid),
        speciesOffers
      )
    } catch (error) {
      throw new OfferFactoryError(error.message)
    }
  }

  private makeResultasOffer (data: ResultasOffer[]): SpeciesOffer[] {
    let speciesOffers: SpeciesOffer[] = []
    for (const offer of data) {
      const offersBySpecies = this.makeResultasSingleOffer(offer)
      speciesOffers = [
        ...speciesOffers,
        ...offersBySpecies
      ]
    }
    return speciesOffers
  }

  private makeResultasSingleOffer (data: ResultasOffer): SpeciesOffer[] {
    const speciesOffers: SpeciesOffer[] = []
    const speciesBinomen = new SpeciesBinomen(data.species)
    if (data.sawOne) {
      speciesOffers.push(new SpeciesOffer(
        Currency.fromString(data.sawOne),
        speciesBinomen,
        data.internalId,
        OfferTarget.SERRA1
      ))
    }
    if (data.sawTwo) {
      speciesOffers.push(new SpeciesOffer(
        Currency.fromString(data.sawTwo),
        speciesBinomen,
        data.internalId,
        OfferTarget.SERRA2
      ))
    }
    if (data.grinded) {
      speciesOffers.push(new SpeciesOffer(
        Currency.fromString(data.grinded),
        speciesBinomen,
        data.internalId,
        OfferTarget.TRITURACION
      ))
    }
    return speciesOffers
  }
}
